/// <reference path="MiniMeAccessory.js" />
/// <reference path="MiniMeSpeechBubble.js" />
/// <reference path="ListenerManager.js" />

const MINI_ME_ACCESSORIES_SETTINGS = {
	itemsPerRow: 3,
	itemHeight: 90,
	itemHeightOffset: 10,
	itemWidth: 90,
	itemWidthOffset: 10,
	maxVisibleRows: 7,
	scrollableContainerWidth: 450,
	scrollableContainerHeight: 798,
	divider: 2.0,
	accessoryWidth: 85,
	accessoryHeight: 85,
	accessoryWidthOffset: 5,
	accessoryHeightOffset: 5,
	accessoryOpacity: 0.3,
	accessoryX: 100,
	accessoryY: 200,
	accessoryDivider: 2,
	accessoryScrollWidth: 280,
	windowRX: 20,
	windowRY: 20,
	overlayFill: "#FFFFFF",
	overlayOpacity: 0.7,
	windowFill: "#AA3333",
	windowStroke: "#000000",
	windowStrokeWidth: "5"
};

class MiniMeAccessoryManager {

	constructor(editor, accessories, feedback, speechBubble) {
		this.listenerManager = new ListenerManager();
		this.accessoryInstances = [];
		this.namespace = "http://www.w3.org/2000/svg";
		this.firstAccessory = true;
		this.editor = editor;
		this.scrollableContent = null;
		this.speechBubble = speechBubble;

		if (GenericSoundsInstance == null) {
			new GenericSounds(feedback);
		}

		for (var i = 0; i < accessories.length; i++) {
			this.accessoryInstances.push(new MiniMeAccessory(this.editor, accessories[i], feedback));
		}

		this.initializeAccessoriesBox();

		if (this.accessoryInstances.length != 0) {
			this.editor.getElementById("boxGroup").style.display = "block";
		}
	}

	initializeAccessoriesBox() {
		this.accessoriesBox = this.editor.getElementById("box");
		this.accessoriesBoxShadow = this.editor.getElementById("boxShadow");

		if (this.accessoryInstances.length != 0) {
			this.listenerManager.safeObserve(this.accessoriesBox, "mouseover", () => { this.accessoriesBoxMouseOver(); });
			this.listenerManager.safeObserve(this.accessoriesBox, "mouseout", () => { this.accessoriesBoxMouseOut(); });
			this.listenerManager.safeObserve(this.accessoriesBox, "mouseup", () => { this.dropItemCheck(); });
			this.listenerManager.safeObserve(this.accessoriesBox, "click", () => { this.openAccessoryPopUp(); });
		}
	}

	accessoriesBoxMouseOver() {
		this.accessoriesBoxShadow.style.display = "block";
		this.accessoriesBox.style.cursor = "pointer";
	}

	accessoriesBoxMouseOut() {
		this.accessoriesBoxShadow.style.display = "none";
	}

	dropItemCheck() {
		var activeItem = this.getActiveItem();

		if (activeItem != null) {
			this.dropItem(activeItem);
		}
	}

	dropItem(item) {
		GenericSoundsInstance.softClickSound();
		this.accessoryInstances[item].hideItem();
	}

	getActiveItem() {
		for (var i = 0; i < this.accessoryInstances.length; i++) {
			if (this.accessoryInstances[i].isActive) {
				return i;
			}
		}
		return null;
	}

	closeOverlay() {
		const overlayGroup = this.editor.querySelector('#overlayGroup');
		if (overlayGroup) {
			overlayGroup.remove();
		}
		// Clear stale reference to avoid memory leaks
		this.scrollableContent = null;
	}

	openAccessoryPopUp() {
		GenericSoundsInstance.softClickSound();
		var rows = Math.floor(this.accessoryInstances.length / MINI_ME_ACCESSORIES_SETTINGS.itemsPerRow);
		if (this.accessoryInstances.length % MINI_ME_ACCESSORIES_SETTINGS.itemsPerRow != 0) {
			rows++;
		}

		var group = this.createOverlay();

		// Add red background window first
		var bgWindow = this.createBackgroundWindow(rows);
		group.appendChild(bgWindow);

		// Create scrollable container on top of background
		var scrollContainer = this.createScrollContainer(rows);
		group.appendChild(scrollContainer);

		// Add border frame on top so it's visible over items
		var borderFrame = this.createBorderFrame(rows);
		group.appendChild(borderFrame);

		this.editor.appendChild(group);

		// Insert accessories into the scroll container instead
		this.insertAccessoriesWithScroll(rows);
	}

	createScrollContainer(rows) {
		var actualRows = Math.min(rows, MINI_ME_ACCESSORIES_SETTINGS.maxVisibleRows);
		var height = actualRows * MINI_ME_ACCESSORIES_SETTINGS.itemHeight + MINI_ME_ACCESSORIES_SETTINGS.itemHeightOffset;
		var width = MINI_ME_ACCESSORIES_SETTINGS.itemsPerRow * MINI_ME_ACCESSORIES_SETTINGS.itemWidth + MINI_ME_ACCESSORIES_SETTINGS.itemWidthOffset;
		var x = (MINI_ME_ACCESSORIES_SETTINGS.scrollableContainerWidth - width) / MINI_ME_ACCESSORIES_SETTINGS.divider;
		var y = (MINI_ME_ACCESSORIES_SETTINGS.scrollableContainerHeight - height) / MINI_ME_ACCESSORIES_SETTINGS.divider;

		// Create foreignObject to embed HTML
		var foreignObject = document.createElementNS(this.namespace, "foreignObject");
		foreignObject.setAttribute("x", x);
		foreignObject.setAttribute("y", y);
		foreignObject.setAttribute("width", width);
		foreignObject.setAttribute("height", height);

		// Create scrollable div
		var scrollDiv = document.createElement("div");
		scrollDiv.style.width = "100%";
		scrollDiv.style.height = "100%";
		scrollDiv.style.overflowY = rows > MINI_ME_ACCESSORIES_SETTINGS.maxVisibleRows ? "scroll" : "hidden"; // Only vertical scroll when needed
		scrollDiv.style.overflowX = "hidden"; // Never show horizontal scroll
		scrollDiv.style.borderRadius = "20px";
		scrollDiv.style.boxSizing = "border-box"; // Include padding in width/height calculation

		foreignObject.appendChild(scrollDiv);

		// Store reference for inserting accessories
		this.scrollableContent = scrollDiv;

		return foreignObject;
	}

	insertAccessoriesWithScroll(rows) {
		var contentDiv = this.scrollableContent;
		var svgContent = document.createElementNS(this.namespace, "svg");
		var contentHeight = rows * MINI_ME_ACCESSORIES_SETTINGS.itemHeight + MINI_ME_ACCESSORIES_SETTINGS.itemHeightOffset;
		svgContent.setAttribute("width", `${MINI_ME_ACCESSORIES_SETTINGS.accessoryScrollWidth}`);
		svgContent.setAttribute("height", contentHeight);

		for (var i = 0; i < this.accessoryInstances.length; i++) {
			var x = i % MINI_ME_ACCESSORIES_SETTINGS.itemsPerRow;
			var y = Math.floor(i / MINI_ME_ACCESSORIES_SETTINGS.itemsPerRow);
			this.insertAccessoryIntoScrollable(svgContent, i, x, y);
		}

		contentDiv.appendChild(svgContent);
	}

	insertAccessoryIntoScrollable(svgContent, i, x, y) {
		var instance = this.accessoryInstances[i];
		var accessory = instance.accessory;

		var clone = document.createElementNS(this.namespace, "image");
		clone.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', accessory.src);

		var newHeight, newWidth;
		if (accessory.height <= MINI_ME_ACCESSORIES_SETTINGS.accessoryHeight && accessory.width <= MINI_ME_ACCESSORIES_SETTINGS.accessoryWidth) {
			newWidth = accessory.width;
			newHeight = accessory.height;
		} else if (accessory.height > accessory.width) {
			var ratio = accessory.height / accessory.width;
			newHeight = MINI_ME_ACCESSORIES_SETTINGS.accessoryHeight;
			newWidth = newHeight / ratio;
		} else {
			var ratio = accessory.width / accessory.height;
			newWidth = MINI_ME_ACCESSORIES_SETTINGS.accessoryWidth;
			newHeight = newWidth / ratio;
		}
		clone.setAttribute("width", newWidth);
		clone.setAttribute("height", newHeight);

		var newX = MINI_ME_ACCESSORIES_SETTINGS.accessoryWidthOffset + x * MINI_ME_ACCESSORIES_SETTINGS.itemWidth;
		if (newWidth < MINI_ME_ACCESSORIES_SETTINGS.accessoryWidth) {
			newX += (MINI_ME_ACCESSORIES_SETTINGS.accessoryWidth - newWidth) / MINI_ME_ACCESSORIES_SETTINGS.accessoryDivider;
		}

		var newY = MINI_ME_ACCESSORIES_SETTINGS.accessoryHeightOffset + y * MINI_ME_ACCESSORIES_SETTINGS.itemHeight;
		if (newHeight < MINI_ME_ACCESSORIES_SETTINGS.accessoryHeight) {
			newY += (MINI_ME_ACCESSORIES_SETTINGS.accessoryHeight - newHeight) / MINI_ME_ACCESSORIES_SETTINGS.accessoryDivider;
		}

		clone.setAttribute("x", newX);
		clone.setAttribute("y", newY);
		clone.style.cursor = "pointer";

		if (accessory.isApplied) {
			clone.style.opacity = MINI_ME_ACCESSORIES_SETTINGS.accessoryOpacity;
		}

		svgContent.appendChild(clone);

		if (this.firstAccessory) {
			this.listenerManager.safeObserve(clone, "click", () => {
				this.speechBubble.show(MiniMeSpeechBubbles["accessory"]);
				this.firstAccessory = false;
			});
		}

		this.listenerManager.safeObserve(clone, "click", () => {
			instance.showItem();
			instance.item.setAttribute("x", MINI_ME_ACCESSORIES_SETTINGS.accessoryX);
			instance.item.setAttribute("y", MINI_ME_ACCESSORIES_SETTINGS.accessoryY);
			this.closeOverlay();
			MiniMeLastVersion++;
		});
	}

	createOverlay() {
		var group = document.createElementNS(this.namespace, "g");
		var overlay = document.createElementNS(this.namespace, "rect");
		overlay.setAttribute("x", "0");
		overlay.setAttribute("y", "0");
		overlay.setAttribute("width", `${MINI_ME_ACCESSORIES_SETTINGS.scrollableContainerWidth}`);
		overlay.setAttribute("height", `${MINI_ME_ACCESSORIES_SETTINGS.scrollableContainerHeight}`);
		overlay.style.fill = MINI_ME_ACCESSORIES_SETTINGS.overlayFill;
		overlay.style.fillOpacity = MINI_ME_ACCESSORIES_SETTINGS.overlayOpacity;
		overlay.id = "overlay";
		group.id = "overlayGroup";
		group.appendChild(overlay);
		this.listenerManager.safeObserve(overlay, "click", this.closeOverlay.bind(this));

		return group;
	}

	createBackgroundWindow(rows) {
		var actualRows = Math.min(rows, MINI_ME_ACCESSORIES_SETTINGS.maxVisibleRows);
		var height = actualRows * MINI_ME_ACCESSORIES_SETTINGS.itemHeight + MINI_ME_ACCESSORIES_SETTINGS.itemHeightOffset;
		var width = MINI_ME_ACCESSORIES_SETTINGS.itemsPerRow * MINI_ME_ACCESSORIES_SETTINGS.itemWidth + MINI_ME_ACCESSORIES_SETTINGS.itemWidthOffset;
		var x = (MINI_ME_ACCESSORIES_SETTINGS.scrollableContainerWidth - width) / MINI_ME_ACCESSORIES_SETTINGS.divider;
		var y = (MINI_ME_ACCESSORIES_SETTINGS.scrollableContainerHeight - height) / MINI_ME_ACCESSORIES_SETTINGS.divider;

		var backgroundWindow = document.createElementNS(this.namespace, "rect");
		backgroundWindow.setAttribute("x", x);
		backgroundWindow.setAttribute("y", y);
		backgroundWindow.setAttribute("width", width);
		backgroundWindow.setAttribute("height", height);
		backgroundWindow.setAttribute("rx", MINI_ME_ACCESSORIES_SETTINGS.windowRX);
		backgroundWindow.setAttribute("ry", MINI_ME_ACCESSORIES_SETTINGS.windowRY);
		backgroundWindow.style.fill = MINI_ME_ACCESSORIES_SETTINGS.windowFill;
		backgroundWindow.style.stroke = "none";
		backgroundWindow.id = "backgroundWindow";

		return backgroundWindow;
	}

	createBorderFrame(rows) {
		var actualRows = Math.min(rows, MINI_ME_ACCESSORIES_SETTINGS.maxVisibleRows);
		var height = actualRows * MINI_ME_ACCESSORIES_SETTINGS.itemHeight + MINI_ME_ACCESSORIES_SETTINGS.itemHeightOffset;
		var width = MINI_ME_ACCESSORIES_SETTINGS.itemsPerRow * MINI_ME_ACCESSORIES_SETTINGS.itemWidth + MINI_ME_ACCESSORIES_SETTINGS.itemWidthOffset;
		var x = (MINI_ME_ACCESSORIES_SETTINGS.scrollableContainerWidth - width) / MINI_ME_ACCESSORIES_SETTINGS.divider;
		var y = (MINI_ME_ACCESSORIES_SETTINGS.scrollableContainerHeight - height) / MINI_ME_ACCESSORIES_SETTINGS.divider;

		var borderFrame = document.createElementNS(this.namespace, "rect");
		borderFrame.setAttribute("x", x);
		borderFrame.setAttribute("y", y);
		borderFrame.setAttribute("width", width);
		borderFrame.setAttribute("height", height);
		borderFrame.setAttribute("rx", MINI_ME_ACCESSORIES_SETTINGS.windowRX);
		borderFrame.setAttribute("ry", MINI_ME_ACCESSORIES_SETTINGS.windowRY);
		borderFrame.style.fill = "none";
		borderFrame.style.stroke = MINI_ME_ACCESSORIES_SETTINGS.windowStroke;
		borderFrame.style.strokeWidth = MINI_ME_ACCESSORIES_SETTINGS.windowStrokeWidth;
		borderFrame.style.pointerEvents = "none";
		borderFrame.id = "borderFrame";

		return borderFrame;
	}

	saveAccessorySettings() {
		var _parameters = new Array();
		var parameter;
		var _ids = new Array();
		var id;
		var _dimensions = new Array();

		for (var i = 0; i < this.accessoryInstances.length; i++) {
			var instance = this.accessoryInstances[i];
			parameter = "{";

			parameter += "\"isApplied\":" + (instance.accessory.isApplied ? "\"True\"" : "\"False\"") + ",";
			parameter += "\"isTopLayer\":" + (instance.accessory.isTopLayer ? "\"True\"" : "\"False\"") + ",";
			parameter += "\"X\":\"" + instance.item.getAttribute("x") + "\",";
			parameter += "\"Y\":\"" + instance.item.getAttribute("y") + "\",";
			parameter += "\"uniqueId\":\"" + instance.accessory.uniqueId + "\"";
			id = instance.accessory.uniqueId;

			parameter += "}";

			_parameters.push(parameter);
			_ids.push(id);

			// Store dimensions for scaling calculation
			if (instance.accessory.isApplied) {
				var dim = {
					x: parseFloat(instance.item.getAttribute("x")),
					y: parseFloat(instance.item.getAttribute("y")),
					width: parseFloat(instance.item.getAttribute("width")),
					height: parseFloat(instance.item.getAttribute("height"))
				};
				_dimensions.push(dim);
			}
		}

		var joinedParameters = _parameters.join(";");
		var joinedIds = _ids.join(";");
		var result = {
			parameters: joinedParameters,
			ids: joinedIds,
			dimensions: _dimensions
		};

		return result;
	}
}
